import React, { useRef } from "react";
import { FixedSizeGrid as Grid } from "react-window";
import AutoSizer from "react-virtualized-auto-sizer";

export function VirtualizedTable({ headers = [], rows = [], height = 500, rowHeight = 36 }) {
  const columnCount = headers?.length || (rows[0] ? rows[0].length : 0);
  const rowCount = rows?.length || 0;
  const scrollRef = useRef(null);

  if (!columnCount || !rowCount) {
    return <div className="flex h-48 items-center justify-center rounded border border-gray-200 bg-gray-50 text-sm text-gray-500">No data available</div>;
  }

  return (
    <div className="h-full w-full overflow-hidden rounded-md border border-gray-200 bg-white shadow-sm">
      <div
        ref={scrollRef}
        className="sticky top-0 z-20 overflow-x-auto overflow-y-hidden border-b border-gray-300 bg-gray-100"
        style={{ scrollbarWidth: "none" }}>
        <div
          className="grid min-w-max text-[13px] font-semibold text-gray-700"
          style={{
            gridTemplateColumns: `repeat(${columnCount}, minmax(150px, 1fr))`,
          }}>
          {headers.map((h, i) => (
            <div
              key={i}
              className="overflow-hidden text-ellipsis whitespace-nowrap border-r border-gray-200 px-3 py-2">
              {String(h || "").trim()}
            </div>
          ))}
        </div>
      </div>

      <div style={{ height }}>
        <AutoSizer>
          {({ width, height }) => {
            if (!width || !height) {
              return <div className="flex h-48 items-center justify-center text-sm text-gray-500">Loading preview...</div>;
            }

            return (
              <Grid
                columnCount={columnCount}
                columnWidth={150}
                height={height}
                rowCount={rowCount}
                rowHeight={rowHeight}
                outerRef={scrollRef}
                width={width}
                overscanRowCount={5}>
                {({ columnIndex, rowIndex, style }) => (
                  <div
                    style={style}
                    className={`overflow-hidden text-ellipsis whitespace-nowrap border-b border-r border-gray-100 px-3 py-2 text-sm text-gray-700 ${rowIndex % 2 ? "bg-gray-50" : "bg-white"} transition hover:bg-blue-50`}>
                    {String(rows[rowIndex]?.[columnIndex] ?? "")}
                  </div>
                )}
              </Grid>
            );
          }}
        </AutoSizer>
      </div>

      {rows.length >= 1000 && <div className="border-t bg-gray-50 py-2 text-center text-xs text-gray-500">Showing first {rows.length} rows (preview truncated)</div>}
    </div>
  );
}
